import { RunningCalculator } from './RunningCalculator.mjs'

/**
 * This is a backup RunningCalculator class that can be used in place of
 * unknown RunningCalculator classes.  It will not do anything, but will not
 * throw errors, only a warning should be shown when it's used - it's likely an
 * indicator that a new RunningCalculator has been added into things by devs
 * and whatever code is using this doesn't yet support it as it currently is and
 * needs updated.  This should only be used if the RunningCalculator class stored
 * is not known at the time of instantiation.
 *
 */
export class FakeRc extends RunningCalculator {
  constructor(targetCalcId) {
    super(targetCalcId, [])
  }

  transition(event, stateData) {
    return false
  }
}
